import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Contribution,
  PaginatedResponse,
  PaginationParams,
} from '../models/contribution.models';

export type ContributionScope = 'me' | 'company';

export interface UserContributionFilters {
  status?: string;
  search?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContributionUserService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/contributions`;

  listContributions(
    scope: ContributionScope,
    filters?: UserContributionFilters,
    pagination?: PaginationParams,
  ): Observable<PaginatedResponse<Contribution>> {
    let params = new HttpParams().set('scope', scope);

    if (filters?.status) {
      params = params.set('status', filters.status);
    }
    if (filters?.search) {
      params = params.set('search', filters.search);
    }
    if (pagination?.page) {
      params = params.set('page', pagination.page.toString());
    }
    if (pagination?.limit) {
      params = params.set('limit', pagination.limit.toString());
    }

    return this.http.get<PaginatedResponse<Contribution>>(this.baseUrl, {
      params,
    });
  }

  getContribution(id: string): Observable<{ data: Contribution }> {
    return this.http.get<{ data: Contribution }>(`${this.baseUrl}/${id}`);
  }

  /**
   * Get the certificate download URL
   * The backend redirects to a signed S3 URL
   */
  getCertificateUrl(id: string): string {
    return `${this.baseUrl}/${id}/certificate`;
  }

  /**
   * Get the invoice download URL
   * The backend redirects to a signed S3 URL
   */
  getInvoiceUrl(id: string): string {
    return `${this.baseUrl}/${id}/invoice`;
  }
}
